import { ReactNode } from 'react';
import cn from 'classnames';

import styles from './tabLinkList.module.scss';

interface ITabLinkListProps {
  /** TabLink elements to render inside the list */
  children: ReactNode,
  /** Additional CSS class */
  className?: string,
  /** Accessible name for the navigation landmark */
  ariaLabel: string,
  /** Test identifier */
  dataTest?: string,
}

const TabLinkList = ({
  children,
  className,
  ariaLabel,
  dataTest = 'tabLinkList',
}: ITabLinkListProps) => (
  <nav className={ cn(styles.tabLinkList, className) } aria-label={ ariaLabel } data-test={ dataTest }>
    { children }
  </nav>
);

export default TabLinkList;
